import Button from 'components/button';

const DescriptionSection = ({ dataCreateMission, sectorsInfo, setPage }) => (
  <div className="mx-6 border-b border-gray-200 py-2">
    <div className="flex justify-between">
      <span className="ft-b text-gray-900 font-medium">Description</span>
      <Button color="DEFAULT" size="SM" onClick={() => setPage(1)}>
        Modifier
      </Button>
    </div>
    <div>
      <p className="ft-sm">
        <span className="text-gray-700 font-medium">Secteur d'activité :</span>{' '}
        {sectorsInfo[dataCreateMission.sector]?.name ||
          dataCreateMission.sector}
      </p>
      <p className="ft-sm">
        <span className="text-gray-700 font-medium">Qualification :</span>{' '}
        {dataCreateMission.title}
      </p>
    </div>
  </div>
);

export default DescriptionSection;
